<template>
  <el-dialog
      title="Архивные абонементы"
      :visible="visible"
      :before-close="close"
      width="592px">

    <div v-loading="loading">

      <subscription-list v-if="subscriptions.length" :subscriptions="subscriptions" :serviceTypes="serviceTypes"/>
      <el-alert
          v-else
          :closable="false"
          title="Нет данных"
          type="warning"
          style="margin-top: 10px">
      </el-alert>

      <el-pagination
          class="pagination"
          background
          v-if="showPagination"
          layout="prev, pager, next"
          :page-size="pagination.per_page"
          :total="pagination.total"
          :current-page="pagination.current_page"
          @current-change="loadMembership"/>
    </div>
    <el-button type="primary" class="btn" @click="close">Закрыть</el-button>

  </el-dialog>
</template>

<script>
import SubscriptionList from "@/components/elements/UserSubscription/SubscriptionList"
import {mapGetters} from "vuex"

export default {
  name: "AllSubscription",
  data() {
    return {
      subscriptions: [],
      serviceTypes: [],
      pagination: {},

      error: null,
      loading: false,
    }
  },
  components: {SubscriptionList},
  props: {
    visible: {
      required: true,
    },
    user: {
      required: true,
    }
  },
  watch: {
    visible(value) {
      if (value) this.loadData()

    }
  },
  computed: {
    ...mapGetters("session", {
          department: "department"
        }
    ),
    showPagination() {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page
      } else return false;
    },
  },
  methods: {
    loadData() {
      this.loadMembership()

    },
    loadMembership(page = 1) {

      let params = {
        params: {
          page
        },
      }

      this.loading = true
      this.$api.membership.getHistoryList(this.user.id, params).then((response) => {
        this.subscriptions = response.data.data

        if (response.data.meta)
          this.pagination = response.data.meta.pagination

      }).catch(res => {

        this.$notify.error({
          title: "Ошибка загрузки абонементов",
          message: res.response.data.message,
        })

      }).finally(() => {
        this.loading = false
      })

    },
    close() {

      this.$emit("close")
    },
  }
}
</script>

<style scoped lang="scss">
.btn {
  margin-top: 24px;
}
</style>
